import { gql } from '@apollo/client';

const CLIP_ELIGIBILITY = gql`
  query ClipEligibilityCriteria($customerId: String!, $accountId: Long!) {
    clipEligibilityCriteria(accountId: $accountId, customerId: $customerId) {
      estimatedNextEvaluationDate
      clipExperienceEnrollmentType
      clipExperienceEligible
      clipExperienceEnrolled
      currentStatementNumber
      spendBonusEnrollment
      evaluationResults {
        creditLineAfterClip
        creditLineBeforeClip
        dateEvaluated
        dateExecuted
        delinquencyDate
        evaluationStatementNumber
        hasPassedActiveLast6MonthsCheck
        hasPassedDelinquenciesCheck
        hasPassedNeverActiveCheck
        hasPassedOverlimitCheck
        isInGoodStanding
        outcome
        policyName
        ineligibilityReason
        accountsEligibility {
          accountId
          delinquencyPassed
          overLimit
        }
      }
    }
  }
`;

export { CLIP_ELIGIBILITY };
